import { createAsyncThunk } from '@reduxjs/toolkit';

import { getLoadProfileListService } from 'services/load_profile.service';

export const getLoadProfileList = createAsyncThunk(
  'loadProfile/list',
  async (_, thunkApi) => {
    try {
      const response = await getLoadProfileListService();

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);
